import {
    RECEIVE_INLINE_STATUS,
    RECEIVE_PARENT_DOMAIN
} from '../../actions/inlineActions';

const InfoReducer = (state = { status: false, parentDomain: null }, action) => {
    Object.freeze(state);
    let newState = _.cloneDeep(state);

    switch (action.type) {
        case RECEIVE_INLINE_STATUS:
            newState.status = action.status;

            return newState;

        case RECEIVE_PARENT_DOMAIN:
            newState.parentDomain = action.domain;

            return newState;

        default:
            return newState;
    }
};

export default InfoReducer;